import { useAppContext } from "../../../../App";
import { authorize } from "../../../../Core";
import { estadosDesignacion, roles } from "../../../../config/constants";
import { useAbmContext } from "../../../../views/abm/useAbmComponent";
import { ActionButton } from "../../../helpers";
import { CheckIcon } from "../../../icons";

export const AprobarDesignacion = ({params}) => {
  const { fireCambiarEstado } = useAbmContext();
  const { claims: { rol } } = useAppContext();

  if(!authorize({rol, inRoles: [roles.DIRECTOR, roles.LIQUIDADOR]})){
    return <></>
  }
  const enabled = rol === roles.LIQUIDADOR || rol === roles.DIRECTOR;

  const handleClick = () => {
    fireCambiarEstado({nuevoEstado: estadosDesignacion.APROBADA, title: "Aprobar", text: "aprobar"});
  }
  return <ActionButton iconButton enabled={enabled} Icon={CheckIcon} onClick={handleClick}/>
}
